import React, { useState } from 'react';
import bemCn from 'bem-cn';
import SvgChevronDown from 'src/assets/svg/SvgChevronDown.svg';
import SvgChevronUp from 'src/assets/svg/SvgChevronUp.svg';
import './style.scss';

const BLOG_CATEGORIES = {
    'dog-training': {
        name: 'Dog Training',
        slug: '/blog/dog-training',
    },
    'dog-reactivity': {
        name: 'Dog Reactivity',
        slug: '/blog/dog-reactivity',
    },
    'dog-enrichment': {
        name: 'Dog Enrichment',
        slug: '/blog/dog-enrichment',
    },
    'sniffspot-community': {
        name: 'Sniffspot Community',
        slug: '/blog/sniffspot-community',
    },
    'dog-trainers': {
        name: 'Top Dog Trainers',
        slug: '/blog/dog-trainers/united-states',
    },
    'city-dog-parks': {
        name: 'City Dog Parks',
        slug: '/blog/city-dog-parks',
    },
    'dog-breeds': {
        name: 'Dog Breeds',
        slug: '/blog/dog-breeds',
    },
    'dog-names': {
        name: 'Dog Names',
        slug: '/dog-names',
    },
    'dog-rescues': {
        name: 'Dog Rescues & Shelters',
        slug: '/dog-rescues',
    },
    'dog-socialization': {
        name: 'Socialization',
        slug: '/blog/dog-socialization',
    },
    'dog-exercise': {
        name: 'Exercise',
        slug: '/blog/dog-exercise',
    },
    'dog-swimming': {
        name: 'Swimming',
        slug: '/blog/dog-swimming',
    },
};

const b = bemCn('sniff-blog-top-nav');

const BlogTopNav = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <div className={b()}>
            <div className="desktop-container">
                <div className={b('top-bar')}>
                    <p className="snif-p snif-medium text-deep c-pointer" onClick={toggleOpen}>
                        All categories
                    </p>
                    <div className={b('top-bar-dropdown')} onClick={toggleOpen}>
                        {isOpen ? <SvgChevronUp /> : <SvgChevronDown />}
                    </div>
                </div>
                <div className={b('top-bar-content', { open: isOpen })}>
                    {Object.keys(BLOG_CATEGORIES).map((k, i) => {
                        const v = BLOG_CATEGORIES[k];
                        return (
                            <a key={k} href={v.slug} className={!isOpen && i > 3 ? 'hidden' : ''}>
                                {v.name}
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BlogTopNav;
